/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_qD_113_68 as Componente_qD_113_68,
  rec_Componente_uk_117_107 as Componente_uk_117_107,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_oi as oi,
  rec_pk as pk,
  rec_sk as sk,
} from "../../runtime/index.jsx";
export function Componente_ok_111_107(e) {
  let t = (0, ReactCompiler.c)(19),
    { unidad: n, resumen: r, resumenError: i } = e,
    a;
  t[0] === n.nombre
    ? (a = t[1])
    : ((a = (
        <h2
          className={`min-w-0 flex-1 truncate text-lg font-medium text-(--text-h)`}
          children={n.nombre}
        />
      )),
      (t[0] = n.nombre),
      (t[1] = a));
  let o;
  t[2] !== n.sedeId || t[3] !== n.sedeNombre
    ? ((o = (
        <Componente_qD_113_68
          sedeId={n.sedeId}
          nombre={n.sedeNombre}
          className={`!text-xs`}
        />
      )),
      (t[2] = n.sedeId),
      (t[3] = n.sedeNombre),
      (t[4] = o))
    : (o = t[4]);
  let s;
  t[5] !== a || t[6] !== o
    ? ((s = (
        <div
          className={`flex flex-wrap items-center gap-2`}
          children={[a, o]}
        />
      )),
      (t[5] = a),
      (t[6] = o),
      (t[7] = s))
    : (s = t[7]);
  let c;
  t[8] === n ? (c = t[9]) : ((c = pk(n)), (t[8] = n), (t[9] = c));
  let l;
  t[10] === c
    ? (l = t[11])
    : ((l = <p className={`text-xs text-(--text)`} children={c} />),
      (t[10] = c),
      (t[11] = l));
  let u;
  t[12] !== r || t[13] !== i
    ? ((u = i ? (
        <p
          className={`flex items-center gap-2 text-sm text-(--text)`}
          children={[
            (0, JSXRuntime.jsx)(oi, {
              className: `h-4 w-4 shrink-0`,
            }),
            ` `,
            i,
          ]}
        />
      ) : r ? (
        <div
          className={`flex flex-wrap items-center gap-x-3 gap-y-1`}
          children={[
            <p className={`text-sm text-(--text-h)`} children={sk(r)} />,
            r.atrasadas > 0 && (
              <span
                className={`text-sm font-medium text-(--error-texto)`}
                children={
                  r.atrasadas === 1 ? `1 atrasada` : `${r.atrasadas} atrasadas`
                }
              />
            ),
            r.totalTareas > 0 && (
              <span
                className={`ml-auto flex items-center gap-2`}
                children={[
                  <Componente_uk_117_107
                    valor={r.avancePromedio}
                    ancho={`w-24`}
                  />,
                  <span
                    className={`text-sm text-(--text-h)`}
                    children={[r.avancePromedio, `%`]}
                  />,
                ]}
              />
            ),
          ]}
        />
      ) : null),
      (t[12] = r),
      (t[13] = i),
      (t[14] = u))
    : (u = t[14]);
  let d;
  return (
    t[15] !== s || t[16] !== l || t[17] !== u
      ? ((d = (
          <div
            className={`animar-entrada flex flex-col gap-2 rounded-2xl border border-(--border) bg-(--bg) px-4 py-3`}
            children={[s, l, u]}
          />
        )),
        (t[15] = s),
        (t[16] = l),
        (t[17] = u),
        (t[18] = d))
      : (d = t[18]),
    d
  );
}
